export default "__VITE_ASSET__EFvkoYJv__"